const toDateString = (dateStr) => {
  const date = new Date(dateStr);
  return date.toDateString();
}

export default toDateString;